import supabase from './supabase';

import normalizePreviewData from './normalizePreviewData';

export default async function getUrlPreviewData(url) {
  if (!url) return null;

  const cleanUrl = (Array.isArray(url) ? url[0] : url).replace(
    /[.,!?;:]+$/,
    '',
  );

  const { data: existing } = await supabase
    .from('link_previews')
    .select()
    .eq('url', cleanUrl)
    .maybeSingle();

  if (existing) {
    return normalizePreviewData(existing);
  }

  try {
    const response = await fetch(
      'https://parcer-z03h.onrender.com/get-metadata',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url: cleanUrl }),
      },
    );

    const meta = await response.json();
    return { ...normalizePreviewData({ ...meta, url: cleanUrl }), isNew: true };
  } catch (err) {
    return null;
  }
}
